export type CatalogProduct = {
  id: number;
  name: string;
  category: string;
  subcategory: string;
  material: string;
  price: number;
  priceDisplay: string;
  badge: string;
  dimensions: string;
  lead: string;
  image: string;
};

export const catalogProducts: CatalogProduct[] = [
  {
    id: 1,
    name: "Meridian Sofa",
    category: "Living Room",
    subcategory: "Sofas",
    material: "Boucle / Walnut",
    price: 3200,
    priceDisplay: "$3,200",
    badge: "Bestseller",
    dimensions: "96\"W × 36\"D × 32\"H",
    lead: "4–6 weeks",
    image: "https://readdy.ai/api/search-image?query=modern%20minimalist%20sofa%20in%20warm%20oatmeal%20boucle%20fabric%2C%20solid%20walnut%20wood%20legs%2C%20clean%20architectural%20lines%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20soft%20studio%20lighting%2C%20full%20product%20view&width=480&height=600&seq=501&orientation=portrait",
  },
  {
    id: 2,
    name: "Halcyon Lounge Chair",
    category: "Seating",
    subcategory: "Lounge Chairs",
    material: "Leather / Brass",
    price: 1650,
    priceDisplay: "$1,650",
    badge: "New",
    dimensions: "32\"W × 34\"D × 30\"H",
    lead: "3–5 weeks",
    image: "https://readdy.ai/api/search-image?query=sculptural%20lounge%20chair%20in%20cognac%20leather%20with%20brushed%20brass%20frame%2C%20mid-century%20modern%20design%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20soft%20studio%20lighting%2C%20full%20product%20view&width=480&height=600&seq=502&orientation=portrait",
  },
  {
    id: 3,
    name: "Crestwood Dining Table",
    category: "Dining",
    subcategory: "Dining Tables",
    material: "White Oak",
    price: 4800,
    priceDisplay: "$4,800",
    badge: "",
    dimensions: "84\"W × 40\"D × 30\"H",
    lead: "6–8 weeks",
    image: "https://readdy.ai/api/search-image?query=solid%20white%20oak%20dining%20table%20with%20live%20edge%20detail%2C%20minimalist%20design%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20overhead%20lighting%2C%20full%20product%20view&width=480&height=600&seq=503&orientation=portrait",
  },
  {
    id: 4,
    name: "Wicker Park Coffee Table",
    category: "Living Room",
    subcategory: "Coffee Tables",
    material: "Travertine / Steel",
    price: 980,
    priceDisplay: "$980",
    badge: "New",
    dimensions: "48\"W × 28\"D × 16\"H",
    lead: "2–4 weeks",
    image: "https://readdy.ai/api/search-image?query=round%20travertine%20stone%20coffee%20table%20with%20matte%20black%20metal%20base%2C%20luxury%20modern%20furniture%2C%20professional%20product%20photography%2C%20warm%20limestone%20background%2C%20soft%20lighting%2C%20full%20product%20view&width=480&height=600&seq=504&orientation=portrait",
  },
  {
    id: 5,
    name: "Lakeview Bed Frame",
    category: "Bedroom",
    subcategory: "Bed Frames",
    material: "Walnut / Linen",
    price: 2900,
    priceDisplay: "$2,900",
    badge: "",
    dimensions: "King: 82\"W × 88\"D × 48\"H",
    lead: "5–7 weeks",
    image: "https://readdy.ai/api/search-image?query=king%20size%20platform%20bed%20frame%20in%20dark%20walnut%20wood%20with%20upholstered%20linen%20headboard%2C%20modern%20bedroom%20furniture%2C%20professional%20showroom%20photography%2C%20warm%20limestone%20background%2C%20soft%20ambient%20lighting%2C%20full%20product%20view&width=480&height=600&seq=505&orientation=portrait",
  },
  {
    id: 6,
    name: "Fulton Bookshelf",
    category: "Storage",
    subcategory: "Shelving",
    material: "Steel / Oak",
    price: 1200,
    priceDisplay: "$1,200",
    badge: "",
    dimensions: "48\"W × 14\"D × 84\"H",
    lead: "3–5 weeks",
    image: "https://readdy.ai/api/search-image?query=tall%20open%20bookshelf%20in%20blackened%20steel%20and%20solid%20oak%20shelves%2C%20industrial%20modern%20design%2C%20styled%20with%20books%20and%20objects%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20dramatic%20lighting%2C%20full%20product%20view&width=480&height=600&seq=506&orientation=portrait",
  },
  {
    id: 7,
    name: "Lincoln Park Sideboard",
    category: "Dining",
    subcategory: "Sideboards",
    material: "Smoked Oak / Brass",
    price: 2400,
    priceDisplay: "$2,400",
    badge: "",
    dimensions: "72\"W × 18\"D × 32\"H",
    lead: "4–6 weeks",
    image: "https://readdy.ai/api/search-image?query=modern%20sideboard%20credenza%20in%20smoked%20oak%20with%20brass%20hardware%2C%20minimalist%20design%2C%20professional%20furniture%20showroom%20photography%2C%20warm%20limestone%20background%2C%20warm%20directional%20lighting%2C%20full%20product%20view&width=480&height=600&seq=507&orientation=portrait",
  },
  {
    id: 8,
    name: "Archer Dining Chair",
    category: "Seating",
    subcategory: "Dining Chairs",
    material: "Walnut / Wool",
    price: 620,
    priceDisplay: "$620",
    badge: "Bestseller",
    dimensions: "20\"W × 22\"D × 34\"H",
    lead: "3–4 weeks",
    image: "https://readdy.ai/api/search-image?query=elegant%20dining%20chair%20in%20solid%20walnut%20with%20charcoal%20wool%20upholstered%20seat%2C%20Scandinavian%20modern%20design%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20soft%20studio%20lighting%2C%20full%20product%20view&width=480&height=600&seq=508&orientation=portrait",
  },
  {
    id: 9,
    name: "Ravenswood Sectional",
    category: "Living Room",
    subcategory: "Sofas",
    material: "Velvet / Oak",
    price: 5600,
    priceDisplay: "$5,600",
    badge: "New",
    dimensions: "120\"W × 90\"D × 30\"H",
    lead: "8–10 weeks",
    image: "https://readdy.ai/api/search-image?query=large%20L-shaped%20sectional%20sofa%20in%20deep%20forest%20green%20velvet%20with%20solid%20oak%20legs%2C%20luxury%20modern%20furniture%2C%20professional%20showroom%20photography%2C%20warm%20limestone%20background%2C%20soft%20ambient%20lighting%2C%20full%20product%20view&width=480&height=600&seq=509&orientation=portrait",
  },
  {
    id: 10,
    name: "Hyde Park Nightstand",
    category: "Bedroom",
    subcategory: "Nightstands",
    material: "Walnut",
    price: 480,
    priceDisplay: "$480",
    badge: "",
    dimensions: "22\"W × 18\"D × 26\"H",
    lead: "2–3 weeks",
    image: "https://readdy.ai/api/search-image?query=minimalist%20walnut%20wood%20nightstand%20with%20single%20drawer%20and%20open%20shelf%2C%20modern%20bedroom%20furniture%2C%20professional%20product%20photography%2C%20warm%20limestone%20background%2C%20soft%20studio%20lighting%2C%20full%20product%20view&width=480&height=600&seq=510&orientation=portrait",
  },
  {
    id: 11,
    name: "Pilsen Bar Stool",
    category: "Seating",
    subcategory: "Bar Stools",
    material: "Steel / Leather",
    price: 390,
    priceDisplay: "$390",
    badge: "",
    dimensions: "16\"W × 18\"D × 30\"H",
    lead: "2–3 weeks",
    image: "https://readdy.ai/api/search-image?query=modern%20counter%20bar%20stool%20in%20matte%20black%20steel%20with%20saddle%20leather%20seat%2C%20industrial%20modern%20design%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20soft%20studio%20lighting%2C%20full%20product%20view&width=480&height=600&seq=511&orientation=portrait",
  },
  {
    id: 12,
    name: "Bridgeport Dresser",
    category: "Bedroom",
    subcategory: "Dressers",
    material: "White Oak / Brass",
    price: 1850,
    priceDisplay: "$1,850",
    badge: "",
    dimensions: "60\"W × 18\"D × 36\"H",
    lead: "5–6 weeks",
    image: "https://readdy.ai/api/search-image?query=six%20drawer%20dresser%20in%20white%20oak%20with%20brushed%20brass%20pulls%2C%20minimalist%20modern%20design%2C%20professional%20furniture%20photography%2C%20warm%20limestone%20background%2C%20soft%20studio%20lighting%2C%20full%20product%20view&width=480&height=600&seq=512&orientation=portrait",
  },
];

export const catalogCategories = [
  { label: "All Pieces", value: "all" },
  { label: "Living Room", value: "Living Room" },
  { label: "Dining", value: "Dining" },
  { label: "Bedroom", value: "Bedroom" },
  { label: "Seating", value: "Seating" },
  { label: "Storage", value: "Storage" },
];

export const catalogMaterials = [
  "Boucle / Walnut",
  "Leather / Brass",
  "White Oak",
  "Travertine / Steel",
  "Walnut / Linen",
  "Steel / Oak",
  "Smoked Oak / Brass",
  "Walnut / Wool",
  "Velvet / Oak",
  "Walnut",
  "Steel / Leather",
  "White Oak / Brass",
];

export const sortOptions = [
  { label: "Featured", value: "featured" },
  { label: "Price: Low to High", value: "price-asc" },
  { label: "Price: High to Low", value: "price-desc" },
  { label: "Newest First", value: "newest" },
];
